/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import Select from '../Select';

const propTypes = {
  onChange: React.PropTypes.func.isRequired,
  options: React.PropTypes.array.isRequired,
  onSelect: React.PropTypes.func,
  placeholder: React.PropTypes.any,
  className: React.PropTypes.string,
};

class SearchSelector extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      options: props.options,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { options } = nextProps;
    if (options !== this.props.options) {
      this.setState({ options });
    }
  }

  render() {
    const {
      placeholder,
      className,
    } = this.props;
    const { options } = this.state;

    return (
      <Select
        onChange={(v) => {
          this.props.onChange(v);
          if (this.props.onSelect) {
            this.props.onSelect(v);
          }
        }}
        placeholder={placeholder}
        className={className}
        options={options}
      />
    );
  }
}

SearchSelector.propTypes = propTypes;

export default SearchSelector;




// WEBPACK FOOTER //
// ./src/components/SearchSelector/index.jsx